import key from "@/assets/img/key.png";
import square from "@/assets/img/square.png";
import userIcon from "@/assets/img/userIcon.png";
import wallet from "@/assets/img/wallet.png";
import discount from "@/assets/img/discount.png";
import message from "@/assets/img/message.png";
import routes from "./routes";
const data = {
  navigation: [
    {
      text: "Dashboard",
      to: "/dashboard",
      src: key,
    },
    {
      text: "Product",
      to: "/product",
      src: square,
    },
    {
      text: "Customers",
      to: routes.CUSTOMERS,
      src: userIcon,
    },
    {
      text: "Income",
      to: "/income",
      src: wallet,
    },
    {
      text: "Promote",
      to: "/Promote",
      src: discount,
    },
    {
      text: "Help",
      to: "/help",
      src: message,
    },
  ],
  users: [
    {
      name: "Jane Cooper",
      company: "Microsoft",
      number: "(225) 555-0118",
      email: "jane@microsoft.com",
      country: "United States",
      status: "Active",
    },
    {
      name: "Floyd Miles",
      company: "Yahoo",
      number: "(205) 555-0100",
      email: "floyd@yahoo.com",
      country: "Kiribati",
      status: "Inactive",
    },
    {
      name: "Ronald Richards",
      company: "Adobe",
      number: "(302) 555-0107",
      email: "ronald@adobe.com",
      country: "Israel",
      status: "Active",
    },
    {
      name: "Marvin McKinney",
      company: "Tesla",
      number: "(252) 555-0126",
      email: "marvin@tesla.com",
      country: "Iran",
      status: "Active",
    },
    {
      name: "Jerome Bell",
      company: "Google",
      number: "(629) 555-0129",
      email: "jerome@google.com",
      country: "Réunion",
      status: "Active",
    },
    {
      name: "Kathryn Murphy",
      company: "Microsoft",
      number: "(704) 555-0127",
      email: "kathryn@microsoft.com",
      country: "Curaçao",
      status: "Inactive",
    },
    {
      name: "Jacob Jones",
      company: "Yahoo",
      number: "(406) 555-0120",
      email: "jacob@yahoo.com",
      country: "Brazil",
      status: "Active",
    },
    {
      name: "Kristin Watson",
      company: "Facebook",
      number: "(208) 555-0112",
      email: "kristin@facebook.com",
      country: "Åland Islands",
      status: "Inactive",
    },
    {
      name: "Jane Cooper",
      company: "Microsoft",
      number: "(225) 555-0118",
      email: "jane@microsoft.com",
      country: "United States",
      status: "Active",
    },
    {
      name: "Floyd Miles",
      company: "Yahoo",
      number: "(205) 555-0100",
      email: "floyd@yahoo.com",
      country: "Kiribati",
      status: "Inactive",
    },
    {
      name: "Ronald Richards",
      company: "Adobe",
      number: "(302) 555-0107",
      email: "ronald@adobe.com",
      country: "Israel",
      status: "Inactive",
    },
    {
      name: "Marvin McKinney",
      company: "Tesla",
      number: "(252) 555-0126",
      email: "marvin@tesla.com",
      country: "Iran",
      status: "Active",
    },
    {
      name: "Jerome Bell",
      company: "Google",
      number: "(629) 555-0129",
      email: "jerome@google.com",
      country: "Réunion",
      status: "Active",
    },
    {
      name: "Kathryn Murphy",
      company: "Microsoft",
      number: "(704) 555-0127",
      email: "kathryn@microsoft.com",
      country: "Curaçao",
      status: "Active",
    },
    {
      name: "Jacob Jones",
      company: "Yahoo",
      number: "(406) 555-0120",
      email: "jacob@yahoo.com",
      country: "Brazil",
      status: "Active",
    },
    {
      name: "Kristin Watson",
      company: "Facebook",
      number: "(208) 555-0112",
      email: "kristin@facebook.com",
      country: "Åland Islands",
      status: "Active",
    },
    {
      name: "Jane Cooper",
      company: "Microsoft",
      number: "(225) 555-0118",
      email: "jane@microsoft.com",
      country: "United States",
      status: "Inactive",
    },
    {
      name: "Floyd Miles",
      company: "Yahoo",
      number: "(205) 555-0100",
      email: "floyd@yahoo.com",
      country: "Kiribati",
      status: "Active",
    },
    {
      name: "Ronald Richards",
      company: "Adobe",
      number: "(302) 555-0107",
      email: "ronald@adobe.com",
      country: "Israel",
      status: "Active",
    },
    {
      name: "Marvin McKinney",
      company: "Tesla",
      number: "(252) 555-0126",
      email: "marvin@tesla.com",
      country: "Iran",
      status: "Active",
    },
    {
      name: "Jerome Bell",
      company: "Google",
      number: "(629) 555-0129",
      email: "jerome@google.com",
      country: "Réunion",
      status: "InAtive",
    },
    {
      name: "Kathryn Murphy",
      company: "Microsoft",
      number: "(704) 555-0127",
      email: "kathryn@microsoft.com",
      country: "Curaçao",
      status: "Active",
    },
    {
      name: "Jacob Jones",
      company: "Yahoo",
      number: "(406) 555-0120",
      email: "jacob@yahoo.com",
      country: "Brazil",
      status: "Active",
    },
    {
      name: "Kristin Watson",
      company: "Facebook",
      number: "(208) 555-0112",
      email: "kristin@facebook.com",
      country: "Åland Islands",
      status: "Active",
    },
    {
      name: "Jane Cooper",
      company: "Microsoft",
      number: "(225) 555-0118",
      email: "jane@microsoft.com",
      country: "United States",
      status: "Active",
    },
    {
      name: "Floyd Miles",
      company: "Yahoo",
      number: "(205) 555-0100",
      email: "floyd@yahoo.com",
      country: "Kiribati",
      status: "Inactive",
    },
    {
      name: "Ronald Richards",
      company: "Adobe",
      number: "(302) 555-0107",
      email: "ronald@adobe.com",
      country: "Israel",
      status: "Active",
    },
    {
      name: "Marvin McKinney",
      company: "Tesla",
      number: "(252) 555-0126",
      email: "marvin@tesla.com",
      country: "Iran",
      status: "Active",
    },
    {
      name: "Jerome Bell",
      company: "Google",
      number: "(629) 555-0129",
      email: "jerome@google.com",
      country: "Réunion",
      status: "Active",
    },
    {
      name: "Kathryn Murphy",
      company: "Microsoft",
      number: "(704) 555-0127",
      email: "kathryn@microsoft.com",
      country: "Curaçao",
      status: "Inctive",
    },
    {
      name: "Jacob Jones",
      company: "Yahoo",
      number: "(406) 555-0120",
      email: "jacob@yahoo.com",
      country: "Brazil",
      status: "Active",
    },
    {
      name: "Kristin Watson",
      company: "Facebook",
      number: "(208) 555-0112",
      email: "kristin@facebook.com",
      country: "Åland Islands",
      status: "Inactive",
    },
    {
      name: "Jane Cooper",
      company: "Microsoft",
      number: "(225) 555-0118",
      email: "jane@microsoft.com",
      country: "United States",
      status: "Active",
    },
    {
      name: "Floyd Miles",
      company: "Yahoo",
      number: "(205) 555-0100",
      email: "floyd@yahoo.com",
      country: "Kiribati",
      status: "Inactive",
    },
    {
      name: "Ronald Richards",
      company: "Adobe",
      number: "(302) 555-0107",
      email: "ronald@adobe.com",
      country: "Israel",
      status: "Inactive",
    },
    {
      name: "Marvin McKinney",
      company: "Tesla",
      number: "(252) 555-0126",
      email: "marvin@tesla.com",
      country: "Iran",
      status: "Active",
    },
    {
      name: "Jerome Bell",
      company: "Google",
      number: "(629) 555-0129",
      email: "jerome@google.com",
      country: "Réunion",
      status: "Active",
    },
    {
      name: "Kathryn Murphy",
      company: "Microsoft",
      number: "(704) 555-0127",
      email: "kathryn@microsoft.com",
      country: "Curaçao",
      status: "Active",
    },
    {
      name: "Jacob Jones",
      company: "Yahoo",
      number: "(406) 555-0120",
      email: "jacob@yahoo.com",
      country: "Brazil",
      status: "Active",
    },
    {
      name: "Kristin Watson",
      company: "Facebook",
      number: "(208) 555-0112",
      email: "kristin@facebook.com",
      country: "Åland Islands",
      status: "Inactive",
    },
  ],
};

export default data;
